import { HttpInterceptorFn } from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";
import { throwError } from "rxjs";

import { handleError } from "@utils/error/error";
import { inject } from "@angular/core";
import { RequestContextService } from "@shared/services/context/request-context.service";
import { pickAllowedHeaders } from "@utils/http/allowed-headers";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const ctx = inject(RequestContextService);
  return next(req).pipe(
    tap(() => ctx.clear()),
    catchError((err) => {
      ctx.requestHeaders = pickAllowedHeaders(req.headers);
      ctx.responseHeaders = pickAllowedHeaders(err.headers);

      return throwError(() => handleError(err));
    }),
  );
};
